/**
 * Formats a decimal transaction rate into a string with '%' sign
 */
export default function formatTransactionRate(rate: number): string {
  return `${(rate * 100).toFixed(2)}%`;
}
